import { useEffect, useState } from 'react';

/** Cookie cms-web writes on a successful submit: `<siteId>.carfax.lead.submitted`. */
export const CARFAX_LEAD_COOKIE_SUFFIX = '.carfax.lead.submitted';

/** dataAttributes key holding the raw CARFAX report URL, set by WIS Carfax.java. */
export const CARFAX_LINK_ATTRIBUTE = 'carfax-link';

/** Visitor half of the gate (component.vm:142). Suffix-matched; cookies are already domain-scoped. */
export const hasSubmittedCarfaxLead = (cookieString = '') =>
	cookieString.split(';').some((entry) => {
		const [name, value] = entry.trim().split('=');
		return (
			name.endsWith(CARFAX_LEAD_COOKIE_SUFFIX) &&
			!!value &&
			value !== 'false'
		);
	});

/** Client-only: a cookie answer in SSR markup would leak one visitor's state to all of them. */
export const useCarfaxLeadSubmitted = () => {
	const [submitted, setSubmitted] = useState(false);

	useEffect(() => {
		setSubmitted(hasSubmittedCarfaxLead(document.cookie));
	}, []);

	return submitted;
};
